import template from "./template_crud";
const workDoc = '/workdoc'
export const getWorkDocList = template.getList(workDoc)
export const getWorkDocById = template.getById(workDoc)
export const getWorkDocByIdPrint = template.getById(workDoc,'/print')
export const getWorkDocByIdAccess = template.getById(workDoc,'/access')
export const addWorkDocOne = template.addOne(workDoc)
export const saveChangeTable = template.updById(workDoc,'/save')
export const updWorkDocProps = template.updById(workDoc)